import StaticPage from 'components/StaticPage/StaticPage';
import { connect } from 'react-redux';

/**
 * Represents the privacy policy static page.
 */
export default connect(
  (state) => ({
    page: state.staticPages.find((item) => item.canonical === 'privacy-policy')
  })
)(StaticPage);
